import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

// In standalone dev mode, seed countryCode from VITE_COUNTRIES so slices
// that read sessionStorage on init pick up the correct market.
if (import.meta.env.DEV && !sessionStorage.getItem('countryCode')) {
  const market = import.meta.env.VITE_COUNTRIES;
  if (market) {
    sessionStorage.setItem('countryCode', market);
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
